export const AdminLeasedetailsDashboards = {
  AdminLeasedetailsDashboards: {
    components: null,
    componentsId: null,
    permissionsId: '2bf1fdae-08ac-4dc1-0773-08dad1f91be5',
    permissionsName: 'Lease Contract'
  },
};
